/**
 * AuthLayout - Layout for login/auth pages
 */

import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

export interface AuthLayoutProps {
  children?: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-dark via-accent to-accent-light flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-2xl shadow-card mb-4">
            <span className="text-accent font-bold text-3xl">C</span>
          </div>
          <h1 className="text-white font-heading text-3xl">Cinco Office</h1>
          <p className="text-white/70 mt-2">Planning & Backoffice Tools</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-card shadow-card p-8">
          {children || <Outlet />}
        </div>

        {/* Footer */}
        <p className="text-center text-white/50 text-sm mt-6">
          © {new Date().getFullYear()} Cinco Cleaning
        </p>
      </div>
    </div>
  );
}
